import React from "react";
import { ButtonIcon, ButtonText } from "@loanbossinc/component-library";
import styled from "styled-components";

const ButtonNameContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    gap: 1em;
    align-items: center;
`;

const Text = styled.div`
    font-family: Work Sans;
    font-size: 16px;
    font-weight: 500;
`;

const PresetsDrawerHeader = ({ title, onClosePresets, saveButton }) => (
  <div className="fp-header-wrapper">
    <ButtonNameContainer>
      <ButtonIcon
        iconName="arrow_back"
        onClick={onClosePresets}
        style={{ color: "#000000" }}
      />
      <Text>{title}</Text>
    </ButtonNameContainer>
    {saveButton()}
  </div>
);

export default PresetsDrawerHeader;
